export default {
      id: "webshop-usage",
      viewBox: "0 0 54 32",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#webshop",
      toString: function () {
        return this.url;
      }
    }